var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"select-wrapper"},[_c('select',{attrs:{"id":_vm.id,"name":_vm.name},on:{"change":_vm.updateValue}},[_vm._l((_vm.options),function(option,index){return [_c('option',{key:index,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }